import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from '@/components/ui/modal';
import type { RootState } from '../../../../store/store';
import {
  cancelAdminStepUp,
  registerAdminStepUpPromptHost,
  resolveAdminStepUp,
} from '../../../../services/adminStepUpPrompt';
import AdminStepUpPanel from './AdminStepUpPanel';

/**
 * The admin step-up prompt (ORA-864), mounted in ProtectedLayout and in the
 * /play admin bar (a public route outside ProtectedLayout; the two never share
 * a page). The axios client opens it when an admin call needs a fresh passkey
 * verification; verifying replays the waiting requests, closing it fails them.
 */
const AdminStepUpModal: React.FC = () => {
  const { isPromptOpen, reason } = useSelector(
    (state: RootState) => state.adminStepUp
  );

  // Lets the axios client know a prompt can be answered here. Unmounting
  // (logout, leaving /play) unregisters, which cancels any waiting requests.
  useEffect(() => registerAdminStepUpPromptHost(), []);

  return (
    <Modal
      open={isPromptOpen}
      onClose={() => cancelAdminStepUp()}
      name="admin-step-up"
      title="Verify it's you"
      className="modal--glass"
      size="sm"
      excludeFromChatSnapshot
    >
      {isPromptOpen && (
        <ModalBody>
          <AdminStepUpPanel
            context="modal"
            reason={reason}
            onVerified={(token) => resolveAdminStepUp(token)}
            onCancel={() => cancelAdminStepUp()}
          />
        </ModalBody>
      )}
    </Modal>
  );
};

export default AdminStepUpModal;
